import * as actionTypes from '../actionTypes'

const formDialog = (state = {
	open: false,
	searchObject: {},
	rerender: false,
	subNafaOpen: false,
	subOpen: false,
	nafaData: [],
	accountTypeOptions: [],
	countryTypeOptions: [],
	goBack: false
}, action) => {
	switch (action.type) {
		case actionTypes.OPEN_DIALOG:
			return {
				...state,
				open: true
			}
		case actionTypes.CLOSE_DIALOG:
			return {
				...state,
				open: false,
				searchObject: {},
			}
		case actionTypes.CLOSE_NESTED_DIALOG:
			return {
				...state,
				subNafaOpen: false,
				subOpen: false
			}
		case actionTypes.DIALOG_CHANGE_SELECT:
			state.searchObject[action.field] = action.value
			return {
				...state,
				searchObject: state.searchObject,
				rerender: !state.rerender
			}
		case actionTypes.DIALOG_CHANGE:
			state.searchObject[action.field] = action.value
			return {
				...state,
				searchObject: state.searchObject,
			}
		case actionTypes.CLEAR:
			return {
				...state,
				searchObject: {},
			}
		default:
			if (action.type === 'DIALOG_SEARCH') {
				return {
					...state
				}
			}
			return {
				...state,
				searchObject: {}
			}
	}
}

export default formDialog


// WEBPACK FOOTER //
// ./src/reducers/formDialog.js